import {
  onBeforeUnmount,
  onMounted,
} from 'vue';

import { pageScrollService } from '@/shared/services';

/**
 * Блокирует прокрутку страницы на время жизни боковой панели (side page),
 * разрешая прокрутку только внутри элемента с атрибутом [data-scroll-area].
 */
export function useSidePageScrollLock (): void {
  onMounted(() => {
    const scrollableContent = document.querySelector<HTMLElement>('[data-scroll-area]');
    if (!scrollableContent) {
      console.warn('[useSidePageScrollLock] Element with [data-scroll-area] not found');
      return;
    }
    pageScrollService.lock([scrollableContent]);
  });

  onBeforeUnmount(() => {
    const scrollableContent = document.querySelector<HTMLElement>('[data-scroll-area]');
    if (!scrollableContent) {
      console.warn('[useSidePageScrollLock] Element with [data-scroll-area] not found');
      return;
    }
    pageScrollService.unlock([scrollableContent]);
  });
}
